import {
  FlexWrap,
  RowNumberData,
} from 'components/TableStyles/TableContentStyles'
import { StyledTable } from 'components/TableStyles/TableStyles'
import React, { useState } from 'react'
import IndividualDriveFilter from './DriveFilter/index'
import DriveStatus from './DriveStatus/index'

import { Spin } from 'antd'
import Button from 'components/Button'
import Flex from 'components/Flex'
import Pagination from 'components/Pagination'
import EmptyCandidateIcon from 'components/icons/EmptyCandidateIcon'
import { NavWrapper } from 'modules/Dashboard/Partials/DashboardRoles/Partials/RolesInfoTable/Style/style'
import StepperDrawer from './DrawerSteps'
import { DriveIDStyle, EmptyWrapper } from './Style/style'

const IndividualDriveTable = ({
  scheduleDrawer,
  setScheduleDrawer,
  candidateDeatils,
  currentPage,
  setCurrentPage,
  setSearchValue,
  isLoading,
  candidateRating,
  setCandidateRating,
  interviewRound,
  setInterviewRound,
  getCandidateList,
  rolesMetrics,
  degreeList,
  setSearchParams,
  checkedKeys,
  setCheckedKeys,
  checkedIds,
  setCheckedIds,
  setSelectedCandidateId,
  setSelectedCandidate,
  collegeList,
  college,
  setCollege,
  setCollegeSearch,
  getCandidateDetails,
  candidateDetails,
  getSingleCandidateInterviewDetails,
  driveId,
  roleId,
  candidateInterviewDetails,
  updateInterviewStatus,
  selectedRoundType,
  getGroupCandidateList,
  groupList,
  groupCandidateList,
  status,
  stage,
  candidateInfoData,
  setCandidateInfoData,
  setStatus,
  filterStatus,
  setFilterStatus,
  getRoleMetrics,
  selectedCandidateId,
  setReleaseOffer,
  currentTab,
  specialisationList,
  specialisationValue,
  setSpecialisationValue,
  setKeySpecialisation,
  keySpecialisation,
  setFilterData,
  setSortQuery,
  sortQuery,
}) => {
  const [customSteps, setCustomSteps] = useState(false)
  const [selectedStudent, setSelectedStudent] = useState()
  const [sortBy, setSortBy] = useState('')
  const [orderBy, setOrderBy] = useState('asc')

  const onSortingChanged = query => {
    setSortQuery(query)
  }

  const onPageChange = pagNum => {
    setCurrentPage(pagNum - 1)
  }

  const onSorting = (pagination, filter, sorter) => {
    setSortBy(sorter)
  }

  const sortFilter = sort => {
    let sortOrder = ''
    if (sort == sortBy) {
      sortOrder = orderBy == 'asc' ? 'desc' : 'asc'
    } else {
      sortOrder = 'asc'
    }
    setOrderBy(sortOrder)
    setSortBy(sort)
    onSortingChanged(`sort=${sort}&order=${sortOrder}`)
  }

  const columns = [
    {
      width: '4%',
      title: 'ID',
      render: (id, record) => (
        <DriveIDStyle>{record?.student?.prefixId || '-'}</DriveIDStyle>
      ),
    },

    {
      width: '16%',
      title: 'Candidate Name',
      dataIndex: 'firstName',
      sorter: true,
      key: 'firstName',
      sortDirections: ['ascend', 'descend'],
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('firstName')
          },
        }
      },
      render: (_, rowData) => {
        return (
          <FlexWrap alignCenter gap="8px">
            <RowNumberData>{rowData?.student?.firstName}</RowNumberData>
          </FlexWrap>
        )
      },
    },

    {
      width: '22%',
      title: 'DEG & Department',
      dataIndex: 'degree',
      sorter: true,
      key: 'degree',
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('degree')
          },
        }
      },
      sortDirections: ['ascend', 'descend'],
      render: (_, rowData) => (
        <RowNumberData>
          {rowData?.student?.currentCourse?.degree} {' ('}{' '}
          {rowData?.student?.currentCourse?.department} {')'}
        </RowNumberData>
      ),
    },
    {
      width: '4%',
      title: 'Specialization',
      dataIndex: 'rating',
      sorter: true,
      key: 'rating',
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('rating')
          },
        }
      },
      sortDirections: ['ascend', 'descend'],
      render: (_, rowData) => (
        <RowNumberData>
          {rowData?.student?.currentCourse?.specialisation || '-'}
        </RowNumberData>
      ),
    },
    {
      width: '10%',
      title: 'Stage',
      dataIndex: 'stage',
      sorter: true,
      key: 'stage',
      onHeaderCell: column => {
        return {
          onClick: () => {
            sortFilter('stage')
          },
        }
      },
      sortDirections: ['ascend', 'descend'],
      render: stage => (
        <RowNumberData>
          {(stage?.length > 18 ? stage?.substr(0, 20) + '..' : stage) || '-'}
        </RowNumberData>
      ),
    },
    {
      width: '5%',
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      sortDirections: ['ascend', 'descend'],
      render: (status, record) => (
        <DriveStatus
          status={record?.status}
          offerStatus={record?.offerStatus}
        />
      ),
    },
    {
      width: '3%',
      title: 'Action',
      render: (text, item) => (
        <Button.Secondary
          text="View"
          onClick={() => {
            actionClicked(item)
          }}
        />
      ),
    },
  ]

  const actionClicked = data => {
    setSelectedStudent(data)
    setCustomSteps(true)
  }

  return (
    <NavWrapper column>
      <IndividualDriveFilter
        getCandidateList={getCandidateList}
        setSearchValue={setSearchValue}
        degreeList={degreeList}
        checkedKeys={checkedKeys}
        setCheckedKeys={setCheckedKeys}
        checkedIds={checkedIds}
        setCheckedIds={setCheckedIds}
        candidateRating={candidateRating}
        setCandidateRating={setCandidateRating}
        setInterviewRound={setInterviewRound}
        setStatus={setStatus}
        setFilterStatus={setFilterStatus}
        setSearchParams={setSearchParams}
        setCollege={setCollege}
        specialisationList={specialisationList}
        currentCount={
          candidateDeatils?.candidateList?.count < 10
            ? candidateDeatils?.candidateList?.count
            : (candidateDeatils?.candidateList?.page + 1) * 10 -
              10 +
              candidateDeatils?.candidateList?.result?.length
        }
        totalCount={candidateDeatils?.candidateList?.count}
        specialisationValue={specialisationValue}
        setSpecialisationValue={setSpecialisationValue}
        setKeySpecialisation={setKeySpecialisation}
        keySpecialisation={keySpecialisation}
        setFilterData={setFilterData}
      />
      <StyledTable
        columns={columns}
        dataSource={candidateDeatils?.candidateList?.result}
        pagination={false}
        onChange={onSorting}
        locale={{
          emptyText: (
            <EmptyWrapper column alignCenter isSpin={isLoading}>
              {!isLoading ? (
                <Flex column alignCenter>
                  <Flex>
                    <EmptyCandidateIcon />
                  </Flex>
                  <div>No candidates found in this stage</div>
                  <div>
                    Please pick a stage from the funnel above to manage the
                    candidates' applications.
                  </div>
                </Flex>
              ) : (
                <Spin />
              )}
            </EmptyWrapper>
          ),
        }}
      />
      <Pagination
        onChange={onPageChange}
        totalPages={candidateDeatils?.candidateList?.count}
        pageSize={10}
        current={currentPage + 1}
      />

      {customSteps && (
        <StepperDrawer
          drawer={customSteps}
          setDrawer={setCustomSteps}
          selectedStudent={selectedStudent}
        />
      )}
    </NavWrapper>
  )
}

export default IndividualDriveTable
